import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25a8f9c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "key-figures-grid" }
const _hoisted_2 = { class: "key-figure-card__label" }
const _hoisted_3 = { class: "key-figure-card__value" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "key-figure-card__accent" }, null, -1))

import { computed, Ref } from 'vue';
import { useRoute } from 'vue-router';

import { useGetCurrentUserKeyFigures } from '@/entities/user/hooks';
import { useGetAnnotationSeveritiesQuery } from '@/entities/annotation-severity/hooks';

import { AnnotationSeverity } from '@/entities/annotation-severity/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'InspectionKeyFigures',
  setup(__props) {

const route = useRoute();

const keyFiguresQueryData: Ref = computed(() => {
  if (route.name === 'visionair-inspection-group') {
    return {
      slug: 'inspection-group',
      id: route.params.inspectionGroup,
    };
  }

  if (route.name === 'visionair-device-group') {
    return {
      slug: 'device-group',
      id: route.params.deviceGroup,
    };
  }

  if (route.name === 'visionair-device') {
    return {
      slug: 'device',
      id: route.params.device,
    };
  }

  if (route.name === 'visionair-dashboard') {
    return {
      slug: 'dashboard',
    };
  }

  return { slug: '', id: null };
});

const hasKeyFiguresQueryData = computed(() => {
  if (!keyFiguresQueryData.value.slug) {
    return false;
  }

  if (keyFiguresQueryData.value.slug === 'dashboard') {
    return true;
  }

  return !!keyFiguresQueryData.value.id;
});
const {
  data: figures,
  isLoading,
  isRefetching,
} = useGetCurrentUserKeyFigures(keyFiguresQueryData, {
  enabled: hasKeyFiguresQueryData,
  refetchOnWindowFocus: false,
  retry: false,
});

const { data: severities } = useGetAnnotationSeveritiesQuery();

const severityColors = computed(() => severities.value?.map((severity: AnnotationSeverity) => ({
  key: severity.name.replaceAll(' ', '-').toLowerCase(),
  color: severity.color,
})));

const hiddenFigureKeys = ['coming-inspections', 'completed-inspections'];

const getFigureColor = (key: string) => severityColors.value?.find(severity => severity.key === key)?.color || '#909399';

const displayedFigures = computed(() => {
  const figuresArray = Object.entries(figures.value || {}).map(([key, value]) => ({
    key,
    value,
  }))
    .filter(figure => !hiddenFigureKeys.includes(figure.key));

  const severityChunk = figuresArray.filter(figure => severityColors.value?.find(severity => severity.key === figure.key));
  const miscChunk = figuresArray.filter(figure => !severityColors.value?.find(severity => severity.key === figure.key));

  return [...severityChunk, ...miscChunk];
});


return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(displayedFigures), (item) => {
      return (_openBlock(), _createElementBlock("article", {
        key: item.key,
        class: "key-figure-card",
        style: _normalizeStyle({ '--figure-accent': getFigureColor(item.key) })
      }, [
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(`misc.${item.key}`)), 1),
        _createElementVNode("strong", _hoisted_3, _toDisplayString(item.value || '0'), 1),
        _hoisted_4
      ], 4))
    }), 128))
  ])), [
    [_directive_loading, _unref(isLoading) || _unref(isRefetching)]
  ])
}
}

})